import { DmsLocations } from "../../auth/Auth";
import { LocationPartCount, PricingType } from "../Integration/DmsSetup";
import { PortalSettingRule } from "../ShopifySetting/Portal Setting Rules/PortalSettingRules";
import { PartsPortalType } from "../ShopifySetting/ShoppingPortal/ShoppingPortal";

export interface ShoppingPortalDto {
  setting: ShoppingPortalSetting;
  paymentType: string;
  dmsLocations: DmsLocations[];
  dmsDealerId: number;
  pricing: PricingType;
}
export interface ShoppingPortalSetting {
  id: string;
  portalName: string;
  primaryPhone: string;
  secondaryPhone: string;
  address: string;
  email: string;
  about: string;
  socialLinks: SocialLinkDto[];
  images: ImageDto[];
  dmsSetupId: string;
  shippingCharge: number;
  hideMfgs?: string[];
  settingRules: PortalSettingRule[];
  activeCategoryFilter?: boolean;
  activeManufacturerFilter?: boolean;
}

export enum PaymentType {
  Gravity,
  PayPal,
}

export interface SocialLinkDto {
  id: string;
  linkType: string;
  linkUrl: string;
  shoppingPortalId: string;
}

export interface ImageDto {
  id: string;
  fileName: string;
  newFileName: string;
  url: string;
  absoluteUrl: string;
  shoppingPortalId: string;
  type: string;
}

export interface CartItem {
  inventoryPartId: string;
  partNumber: string;
  description: string;
  mfrCode: string;
  price: number;
  quantity: number;
  locationCount: LocationPartCount[];
}
export interface ShoppingPortalState {
  storeUrl?: string;
  logoUrl?: string;
  portalSettings?: ShoppingPortalDto;
  cart: CartItem[];
  openCheckout: boolean;
  expiryTime: number;
  portalType: PartsPortalType;
  isPortalEnabled: boolean;
}

export const ShoppingPortalInitialState: ShoppingPortalState = {
  cart: [],
  openCheckout: false,
  expiryTime: 0,
  isPortalEnabled: false,
  portalType: PartsPortalType.StandAlone,
};
